import { useIntl } from "react-intl";
import { EventContentArg } from "@fullcalendar/core";

export function useEventDisplayTime(eventInfo: EventContentArg) {
  const intl = useIntl()
  if (!eventInfo?.event?.extendedProps.status) return eventInfo.timeText
  if (eventInfo?.event?.allDay) return intl.formatMessage({id: "appointment.list.view.event.all.day"})
  else return `${eventInfo?.event?.extendedProps.displayStartTime} - ${eventInfo?.event?.extendedProps.displayEndTime}`
}